export default __webpack_public_path__ + "static/media/ro_color.c4725802.svg";